<script>
export default {
  name: 'CardStatuses',
  props: {
    status: {
      type: Object,
      required: true,
    },
  },
  computed: {
    rgbaColor() {
      const { color } = this.status
      const r = parseInt(color.slice(1, 3), 16)
      const g = parseInt(color.slice(3, 5), 16)
      const b = parseInt(color.slice(5, 7), 16)

      return `background-color: rgb(${r}, ${g}, ${b})`
    },
  },
}
</script>

<template>
  <div
    class="flex inset-0 overflow-hidden p-2 rounded truncate"
    :title="status.option"
    :style="rgbaColor"
  >
    <div class="truncate">{{ status.option }}</div>
  </div>
</template>
